import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Form } from "antd";
import axios from "axios";

import DocumentationContext from "../store/documentation-context";
import { parseYear } from "./../services/forms";

import ActaForm from "../components/acta/acta-form";
import Card from "../components/ui/card";
import Content from "../components/ui/content";
import Header from "../components/ui/header";
import Footer from "../components/ui/footer";
import Stepper from "../components/ui/stepper";

const ActaPage = () => {
  const history = useHistory();
  const [form] = Form.useForm();

  const documentationCtx = useContext(DocumentationContext);
  const [loading, setLoading] = useState(false);

  const onBack = () => {
    history.push("/");
  };

  const onNext = async () => {
    const valid = await form.validateFields();

    if (valid) {
      const values = form.getFieldValue();

      const anio = parseYear(values.anio);
      const url = `/documentacion?numero=${values.numero}&anio=${anio}&documento=${values.documento}`;

      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}${url}`
        );
        setLoading(false);

        if (response && response.data.exists) {
          documentationCtx.updateForm(
            values.numero,
            values.anio,
            values.documento
          );
          history.push("/files");
        } else {
          history.push("/not-found");
        }
      } catch (error) {
        history.push("/error");
      }
    }
  };

  return (
    <Card>
      <Header />
      <Content>
        <Stepper />
        <ActaForm form={form} />
      </Content>
      <Footer>
        <Button type="secondary" onClick={onBack}>
          Volver
        </Button>
        <Button type="primary" onClick={onNext} loading={loading}>
          {loading ? "Buscando..." : "Siguiente"}
        </Button>
      </Footer>
    </Card>
  );
};

export default ActaPage;
